import { Injectable } from '@angular/core';

import { LayoutContainerComponent } from '@layout/containers/layout-container/layout-container.component';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  #layoutElement: LayoutContainerComponent | undefined;

  public get layoutElement(): LayoutContainerComponent | undefined {
    return this.#layoutElement;
  }

  public set layoutElement(value: LayoutContainerComponent | undefined) {
    this.#layoutElement = value;
  }

  public closeNavbar() {
    this.#layoutElement?.sidenav!.close();
  }
}
